import { mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["Separator"], _mergeProps({ "data-slot": "separator" }, $setup.delegatedProps, {
        class: $setup.cn('bg-border shrink-0 data-[orientation=horizontal]:h-px data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-px', $setup.props.class)
    }), null, 16 /* FULL_PROPS */, ["class"]));
}
